/**
 * PhoneNumber mapper - converts API response types to domain entities
 */
import type { PhoneNumberResponse } from "../../shared/api/phone";
import type { PhoneNumber } from "./model";

/**
 * Map API PhoneNumberResponse to domain PhoneNumber entity
 */
export function mapPhoneNumberResponseToEntity(
  response: PhoneNumberResponse,
): PhoneNumber {
  return {
    id: response.id,
    msisdn: response.msisdn,
    walletId: response.walletId,
    walletFriendlyAddress: response.wallet?.friendlyAddress ?? null,
    userId: response.userId,
    nftId: response.nftId,
    balance: String(response.balance ?? '0'),
    currency: response.currency ?? 'USD',
    callDst: response.callDst,
    smsDst: response.smsDst,
    status: response.status,
    activatedAt: response.activatedAt
      ? new Date(response.activatedAt)
      : null,
    lastBalanceSyncAt: response.lastBalanceSyncAt
      ? new Date(response.lastBalanceSyncAt)
      : null,
    auctionEndTime: response.auctionEndTime
      ? new Date(response.auctionEndTime)
      : null,
    esimProfile: response.esimProfile
      ? {
          id: response.esimProfile.id,
          iccid: response.esimProfile.iccid,
          activationCode: response.esimProfile.activationCode,
          smdpPlus: response.esimProfile.smdpPlus,
          status: response.esimProfile.status,
        }
      : null,
    createdAt: new Date(response.createdAt),
    updatedAt: new Date(response.updatedAt),
  };
}

